export var ROUTE_EVENTS;
(function (ROUTE_EVENTS) {
    ROUTE_EVENTS["REGISTER"] = "RouteEvent.Register";
})(ROUTE_EVENTS || (ROUTE_EVENTS = {}));
